import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import $ from "jquery";
import Icon from "../common/icon/icon.component.jsx";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import ActionButton from "../common/button/actionbutton.component.jsx";
const uuidv4 = require('uuid/v4')
import Checkbox from "../common/checkbox/checkbox.component.jsx";
import InputUnitOfMeasure from "../common/unit-of-measure/input.component.jsx"
import moment from "moment";
import EventBus from "../common/EventBus.js";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import StandardList from '../common/listing/list.component.jsx'
import {isBundle, isBundleItem} from "../utils"

class ReturnModal extends Component {

    constructor(props, context) {
        super(props, context)

        const itemsListToReturn = this.props.invoice.attributes.items.map(item => {
            item.checked = true
            item.attributes.measureReturned = 0
            item.attributes.measureToReturn = 0
            item.attributes.maxMeasureReturned = 0
            return item
        })

        const dueDate = moment();

        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'return-modal-' + uuidv4(),
            invoice: this.props.invoice || {},
            itemsListToReturn,
            checkAll: true,
            dueDate,
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
        this.onItemChecked = this.onItemChecked.bind(this)
        this.onItemInputChange = this.onItemInputChange.bind(this)
        this.onCheckAll = this.onCheckAll.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            invoice: nextProps.invoice || null,
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        this.refreshSearch()
    }

    closeModal(returnId) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(returnId)
        }
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    allowReturn() {
        return this.state.itemsListToReturn.filter(item => item.checked && item.attributes.measureToReturn > 0).length
    }

    submit(e) {
        e.preventDefault()
        const itemsListToReturn = this.state.itemsListToReturn.filter(item => item.attributes.measureToReturn > 0)
        const data = {
            sellerId: this.state.invoice.attributes.seller.id,
            projectId: this.state.invoice.attributes.projectId,
            contactId: this.state.invoice.attributes.contactId,
            priceListId: this.state.invoice.attributes.priceListId,
            billingType: "return",
            dueDate: this.state.dueDate.format(),
            returnOfInvoiceId: this.state.invoice.id,
            rows: itemsListToReturn.map(item => {
                return {
                    referenceRowId: item.id,
                    measure: item.attributes.measureToReturn > 0 ? '-' + item.attributes.measureToReturn : '0',
                    //additionalMeasure: item.attributes.additionalMeasure,
                    productId: item.attributes.itemObject.id,
                    groupId: item.attributes.groupId,
                    status: item.attributes.type,
                }
            }),
        }

        AppContext.getApiClient().post(`/invoices/${this.state.invoice.id}/return`, data).then(inv => {
            EventBus.dispatch(EventBus.TopicUrlPathChange, {
                path: `/returns/${inv.id}/edit`
            })
            this.closeModal(inv.id)
        })
    }


    refreshSearch() {
        this.setState({
            loading: true
        })

        AppContext.getApiClient().get(`/invoices/${this.state.invoice.id}/returns`).then(res => {
            let itemsListToReturn = this.state.itemsListToReturn
            for (let ret of res.data) {
                if (["draft", "fully-paid", "partially-paid", "sent"].includes(ret.attributes.status)) {
                    for (let item of ret.attributes.items) {
                        let referenceRowId = item.attributes.referenceRowId
                        let itemToReturn = this.state.itemsListToReturn.find(item => item.id === referenceRowId)

                        if (itemToReturn) {
                            let measureReturned = parseFloat(itemToReturn.attributes.measureReturned) - parseFloat(item.attributes.measure)
                            itemToReturn.attributes.measureReturned = measureReturned

                            if ((parseFloat(itemToReturn.attributes.measureReturned) >= parseFloat(itemToReturn.attributes.measure))) {
                                itemToReturn.disabled = true
                                itemToReturn.checked = false
                            }
                        }
                    }
                }
            }

            itemsListToReturn = itemsListToReturn.filter(item => !isBundleItem(item))

            itemsListToReturn = itemsListToReturn.map(item => {
                item.attributes.measureToReturn = parseFloat(item.attributes.measure) - parseFloat(item.attributes.measureReturned)
                if (item.attributes.measureToReturn < 0)
                    item.attributes.measureToReturn = 0
                if (item.attributes.measure <= 0) {
                    item.disabled = true
                    item.checked = false
                }
                item.attributes.maxMeasureReturned = item.attributes.measureToReturn
                return item
            })
            this.setState({
                itemsListToReturn,
                loading: false,
            })
        })
    }

    onCheckAll(isChecked) {
        this.setState({
            checkAll: isChecked,
            itemsListToReturn: this.state.itemsListToReturn.map(item => {
                item.checked = !item.disabled ? isChecked : false
                item.attributes.measureToReturn = isChecked ? item.attributes.maxMeasureReturned : 0
                return item
            })
        })
    }

    onItemChecked(item, isChecked) {
        item.checked = isChecked
        item.attributes.measureToReturn =
            isChecked ? item.attributes.maxMeasureReturned : 0

        this.setState({
            itemsListToReturn: [...this.state.itemsListToReturn]
        })
    }

    onItemInputChange(item, val) {
        if (parseFloat(val) > item.attributes.maxMeasureReturned)
            val = item.attributes.maxMeasureReturned
        else if (parseFloat(val) < 1)
            val = 1

        item.attributes.measureToReturn = val
        this.setState({
            itemsListToReturn: [...this.state.itemsListToReturn]
        })
    }


    headers() {
        return [
            <FormattedMessage
                id="invoice.return_modal.product_name_label"
                defaultMessage="Product name"
            />,
            <FormattedMessage
                id="invoice.return_modal.quantity_sold_label"
                defaultMessage="Quantity sold"
            />,
            <FormattedMessage
                id="invoice.return_modal.quantity_already_returned_label"
                defaultMessage="Already returned"
            />,
            <FormattedMessage
                id="invoice.return_modal.quantity_to_be_returned_label"
                defaultMessage="To be returned"
            />,
            <Checkbox id={'check-all'}
                checked={this.state.checkAll}
                onChange={isChecked => this.onCheckAll(isChecked)} />,
        ]
    }

    row(item) {
        return [
            <div>
                {item.attributes.activeTitle}
            </div>,
            <div className="text-center">
                {item.attributes.measure}
            </div>,
            <div className="text-center">
                {item.attributes.measureReturned}
            </div>,
            <div className="input-group m-1">
                <InputUnitOfMeasure
                    disabled={item.disabled || isBundle(item)}
                    debounced={true}
                    value={item.attributes.measureToReturn}
                    unit={item.attributes.unitOfMeasure}
                    onChange={val => this.onItemInputChange(item, val)}
                />
            </div>,
            !item.disabled ? <Checkbox id={'returned-item-' + item.id}
                checked={item.checked}
                onChange={isChecked => this.onItemChecked(item, isChecked)} style={{ top: 0 }} /> : ''
        ]
    }


    render() {
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="returnModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="returnModalTitle">
                            <Icon value={'undo'} className={'mr-2'} />
                            <FormattedMessage
                                id="invoice.return_modal.title"
                                defaultMessage="New return"
                            />
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            {!this.state.loading ? [<h5>
                                <FormattedMessage
                                    id="invoice.return_modal.select_product_to_return_label"
                                    defaultMessage="Select products to return"
                                />
                            </h5>,
                            <StandardList
                                className="row"
                                headers={this.headers()}
                                rows={this.state.itemsListToReturn.map(item => this.row(item))}
                                smallLine={true}
                            />] : <LoadingSpinner />
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="invoice.void_modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                        <ActionButton
                            type="button"
                            className="btn btn-warning"
                            onClick={this.submit}
                            disabled={!this.allowReturn()}
                        >
                            <FormattedMessage
                                id="invoice.return_modal.create_btn"
                                defaultMessage="Create return"
                            />
                        </ActionButton>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(ReturnModal)



// WEBPACK FOOTER //
// ./src/invoice/returnmodal.component.jsx